import { CSSObject } from 'styled-components';

import theme from '@adsk/alloy-react-theme';

export const leftPositionedDropdown: CSSObject = {
  width: '300px',
  marginRight: theme.spacing.M,
};
